import { SafeLogErrorOptions } from '../log-error';
import { BaseError } from './BaseError';

export class MediaTrackError extends BaseError {
    constructor(message: string, loggerFields: SafeLogErrorOptions, stack?: string) {
        super(
            message,
            {
                source: 'backend',
                block: 'mediatrack',
                ...loggerFields,
            },
            stack
        );

        Object.setPrototypeOf(this, MediaTrackError.prototype);
    }
}
